export * from './base'
export * from './home'
export * from './about'
export * from './games'
export * from './news'
export * from './privacy'
export * from './privacy-policy'
export * from './support'
export * from './terms-service'
